<script lang="ts">
    // Casca comum das etapas do onboarding: cabeçalho com título, descrição e os botões da etapa,
    // e abaixo a área de conteúdo. Antes cada etapa repetia esse bloco e o mesmo CSS — eram sete
    // cópias, e qualquer ajuste de aparência precisava ser feito sete vezes.
    export let title: string = ''
    export let label: string = ''
</script>

<div class="ob-step">
    <div class="ob-step_head">
        <div class="spacer">
            <div class="ob-step_title">{title}</div>
            <div class="ob-step_label">{label}</div>
        </div>
        <slot name="acts" />
    </div>
    <div class="ob-step_content">
        <slot />
    </div>
</div>

<style>
    .ob-step {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .ob-step_head {
        background: #99999915;
        border-bottom: 1px solid #99999933;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 16px;
    }

    /* mesmo tamanho e peso do título de um Zgrid: é o tamanho de "título de tela" no app inteiro */
    .ob-step_title {
        font-weight: 300;
        font-size: 22px;
    }

    /* mesma discrição do headline do Zframe, para a descrição não competir com o título */
    .ob-step_label {
        font-size: 14px;
        opacity: 0.6;
    }

    .ob-step_content {
        flex-grow: 1;
        padding: 16px;
        font-size: 14px;
    }

    /* Tipografia do conteúdo em um lugar só. Precisa ser :global porque o conteúdo entra por slot —
       os elementos pertencem à etapa que chamou, e o CSS com escopo daqui não os alcançaria.
       A escala segue a do design system (14px de corpo, como o rótulo do Zinput) em vez dos 18px e
       dos h3/h4 do bootstrap, que deixavam o texto pesado demais para uma tela de configuração. */
    :global(.ob-step_content h3),
    :global(.ob-step_content h4),
    :global(.ob-step_content h5),
    :global(.ob-step_content h6) {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    :global(.ob-step_content p),
    :global(.ob-step_content ul),
    :global(.ob-step_content li) {
        font-size: 14px;
    }

    :global(.ob-step_content b) {
        font-weight: 600;
    }
</style>
